import { createSlice } from '@reduxjs/toolkit'

import { getCategories, getStore } from './actions'

import { ICategoriesSliceState } from './types'

export const initialState: ICategoriesSliceState = {
  categories: {
    data: [],
    loading: false,
    error: null,
  },
  store: {
    data: [],
    loading: false,
    error: null,
  },
}

const categoriesSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCategories.pending, state => {
      state.categories.loading = true
      state.categories.error = null
    })
    builder.addCase(getCategories.fulfilled, (state, { payload }) => {
      state.categories.loading = false
      state.categories.data = payload
    })
    builder.addCase(getCategories.rejected, (state, { payload }) => {
      state.categories.loading = false
      state.categories.error = payload as null
    })

    builder.addCase(getStore.pending, state => {
      state.store.loading = true
      state.store.error = null
    })
    builder.addCase(getStore.fulfilled, (state, { payload }) => {
      state.store.loading = false
      state.store.data = payload
    })
    builder.addCase(getStore.rejected, (state, { payload }) => {
      state.store.loading = false
      state.store.error = payload as null
    })
  },
})

export const { name, actions } = categoriesSlice

const categoriesReducer = categoriesSlice.reducer

export default categoriesReducer
